import {
  Component,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  signal,
} from "@angular/core";
import * as Highcharts from "highcharts/highstock";
import {
  HighchartsChartComponent,
  providePartialHighcharts,
} from "highcharts-angular";
import { HC_COLORS } from "../highcharts-shared";

/** Ordered series colour palette – mirrors the ENGINEERING.md Highcharts colour order. */
export const high_colors = [
  HC_COLORS.accent,   // #7C5CFF – series 0
  HC_COLORS.pos,      // #00E5A0 – series 1
  HC_COLORS.info,     // #54C7FF – series 2
  HC_COLORS.warn,     // #FFB547 – series 3
  HC_COLORS.neg,      // #FF5C7A – series 4
  HC_COLORS.accent2,  // #A78BFF – series 5
  // Extended palette (no design token – kept as named hex)
  '#4DA68A', // teal
  '#9573FF', // mid-purple
  '#6FA8FF', // cornflower
  '#C05A78', // rose
  '#B07CFF', // lavender
  '#1A1A28', // deep bg (used as last-resort series)
];

@Component({
  selector: "app-general-chart",
  templateUrl: "./general-chart.component.html",
  styleUrls: ["./general-chart.component.scss"],
  imports: [HighchartsChartComponent],
  standalone: true,
  providers: [
    providePartialHighcharts({
      modules: () => [
        import("highcharts/esm/modules/stock"),
        import("highcharts/esm/modules/series-label"),
      ],
    }),
  ],
})
export class GeneralChartComponent implements OnInit, OnChanges {
  loaded = signal(false);

  @Input() data: any = {};
  @Input() series: any[] = [];
  @Input() fullHeight = false;
  @Input() extraOptions = {};

  chartInstance: Highcharts.Chart;
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = "stockChart";
  chartOptions: Highcharts.Options = {};

  constructor(private injector: Injector) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.series) {
      this.loaded.set(false);
      this.series = changes.series.currentValue;
      this.initChart();
    }
  }

  setChartInstance(chart: Highcharts.Chart) {
    this.chartInstance = chart;
  }

  initChart() {}
}
